import React, { useState } from "react";
import PropTypes from "prop-types";
import { FormattedMessage, useIntl } from "react-intl";
import { Row, Col, Form, Button } from "react-bootstrap";

import { formatDate } from "../../../../utils/date-utils/date-utils";
import { TemplateSelect } from "./template-select";
import { UserSelect } from "./user-select";

export const ServiceWorksheetSearch = ({
  salesOrderNumber,
  templateId,
  userIds,
  date,
  status,
  handleSearch,
}) => {
  const intl = useIntl();

  const [salesOrderNumberValue, setSalesOrderNumberValue] = useState(
    salesOrderNumber ? salesOrderNumber : "",
  );
  const [templateIdValue, setTemplateIdValue] = useState(
    templateId ? templateId : null,
  );
  const [userIdsValue, setUserIdsValue] = useState(userIds ? userIds : []);
  const [dateValue, setDateValue] = useState(date ? +date : "");
  const [statusValue, setStatusValue] = useState(status ? status : "ALL");

  const onSearch = (e) => {
    e.preventDefault();
    handleSearch({
      salesOrderNumber:
        salesOrderNumberValue === "" ? null : salesOrderNumberValue,
      templateId: templateIdValue ? +templateIdValue : null,
      userIds: userIdsValue.length === 0 ? null : userIdsValue,
      date: dateValue === "" ? null : new Date(dateValue).getTime(),
      status: statusValue === "ALL" ? null : statusValue,
    });
  };

  return (
    <Form onSubmit={onSearch}>
      <Row>
        <Col xs={12} md={2} className="mb-2 mb-md-0">
          <Form.Control
            type="text"
            placeholder={intl.formatMessage({
              id: "data.serviceworksheet.form.salesorder.number.placeholder",
            })}
            onChange={(e) => setSalesOrderNumberValue(e.target.value)}
            value={salesOrderNumberValue}
          />
        </Col>
        <Col xs={12} md={2} className="mb-2 mb-md-0">
          <Form.Control
            type="date"
            onChange={(e) => setDateValue(e.target.value)}
            value={
              dateValue ? formatDate(new Date(dateValue), "YYYY-MM-DD") : ""
            }
          />
        </Col>
        <Col xs={12} md={2} className="mb-2 mb-md-0">
          <Form.Select
            onChange={(e) => setStatusValue(e.target.value)}
            value={statusValue}
          >
            <option value="ALL">
              <FormattedMessage id="data.serviceworksheet.data.status.value.ALL" />
            </option>
            <option value="DRAFT">
              <FormattedMessage id="data.serviceworksheet.data.status.value.DRAFT" />
            </option>
            <option value="ALLOCATED">
              <FormattedMessage id="data.serviceworksheet.data.status.value.ALLOCATED" />
            </option>
            <option value="UPLOADED">
              <FormattedMessage id="data.serviceworksheet.data.status.value.UPLOADED" />
            </option>
            <option value="DONE">
              <FormattedMessage id="data.serviceworksheet.data.status.value.DONE" />
            </option>
            <option value="CLOSED">
              <FormattedMessage id="data.serviceworksheet.data.status.value.CLOSED" />
            </option>
            <option value="DELETED">
              <FormattedMessage id="data.serviceworksheet.data.status.value.DELETED" />
            </option>
          </Form.Select>
        </Col>
        <Col xs={12} md={2} className="mb-2 mb-md-0">
          <TemplateSelect
            templateId={templateIdValue}
            handleTemplateSelect={(template) =>
              setTemplateIdValue(template?.id ? template.id : null)
            }
          />
        </Col>
        <Col xs={12} md={2} className="mb-2 mb-md-0">
          <UserSelect
            userId={userIdsValue.length === 1 ? userIdsValue[0] : null}
            handleUserSelect={(user) => {
              setUserIdsValue(user?.id ? [user.id] : []);
            }}
          />
        </Col>
        <Col xs={12} md={2} className="text-md-end">
          <Button type="submit">
            <FormattedMessage id="button.search" />
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

ServiceWorksheetSearch.propTypes = {
  salesOrderNumber: PropTypes.string,
  templateId: PropTypes.number,
  userIds: PropTypes.array,
  date: PropTypes.number,
  status: PropTypes.string,
  handleSearch: PropTypes.func.isRequired,
};
